<template>
	<div class="order-reason">
		<div class="form-item" v-for="(item, idx) in officialReasons">
			<div>{{ item.content }}</div>
			<div class="radio-container">
				<nio-radio :value="cur === idx ? '1' : '0'" @input="v => handleInput(idx, v)" label="1" />
			</div>
		</div>
		<div v-show="cur === 5">
			<nio-field v-model="customReason" placeholder="请填写补充描述" />
			<p v-if="showTips" class="content-tips" ref="contentTips">
				*退款金额将原路退回到您的支付账户中
			</p>
		</div>
	</div>
</template>

<script>
import nativeHybrid from '@/util/nativeHybrid'

export default {
	name: 'OrderReason',
	props: {
		showTips: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			cur: null,
			customReason: '',
			officialReasons: [
				{ content: '误操作下单', code: 1 },
				{ content: '转购新车', code: 3 },
				{ content: '车况不满意', code: 4 },
				{ content: '资金问题', code: 5 },
				{ content: '不符合新能源车辆购买资质', code: 6 },
				{ content: '其他', code: 7 }
			]
		}
	},
	mounted() {
		nativeHybrid.registerKeyboardStateChange(l => {
			const isAndroid = navigator.userAgent.match('Android')
			if (isAndroid) {
				document.body.style.minHeight = '100%'
				document.body.style.boxSizing = 'content-box'
				document.body.style.paddingBottom = l / window.devicePixelRatio + 'px'

				window.scrollTo({ top: document.body.clientHeight })
			}
		})
	},
	methods: {
		handleInput(idx, selected) {
			if (!selected) {
				this.cur = null
			} else {
				this.cur = idx
			}
		},
		onChanged() {
			this.$emit('change', {
				code: this.officialReasons[this.cur].code,
				desc: this.customReason
			})
		}
	},
	watch: {
		cur(cur) {
			if (cur === 5) {
				this.customReason = ''
			}

			this.onChanged()
		},
		customReason() {
			this.onChanged()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@nio-fe/nio-app-ui/es/style';
.order-reason {
	.form-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 64px;

		> :first-child {
			@include body_1(1.5, 400, false);
			color: $text_primary;
		}
	}

	.radio-container {
		::v-deep {
			.nio-radio {
				margin-right: 0;
			}
		}
	}

	.content-tips {
		@include body_3(1.5, 400, false);
		color: $text_tertiary;
	}
}
</style>
